export const POUNDS = "lb";
export const KILOS = "kg";
export const KG_PER_LB = 0.453592;

export const ECCN = "european_commerce_control_number";
export const SCHEDULE_B_OR_HT_CODE = "schedule_b_or_ht_code";
export const HTSUS_CODE = "htsus_code";
export const HTSUS_CODE_LABEL = "Harmonized Tariff (HT) Code";

export const WIDTH = "width";
export const HEIGHT = "height";
export const LENGTH = "length";
export const WEIGHT = "weight";
export const WEIGHT_OZ = "weight_oz";
export const WEIGHT_UNIT = "weight_unit";

export const NET_WIDTH = "net_width";
export const NET_HEIGHT = "net_height";
export const NET_LENGTH = "net_length";
export const NET_WEIGHT = "net_weight";
export const NET_WEIGHT_OZ = "net_weight_oz";
export const NET_WEIGHT_UNIT = "net_weight_unit";

export const HIGHER_ASSEMBLY_APPLICATION = "HigherAssemblyApplication";
export const LOWER_ASSEMBLY_APPLICATION = "LowerAssemblyApplication";
export const ENGINE_APPLICATION = "EngineApplication";
export const AIRCRAFT_APPLICATION = "AircraftApplication";

export const APPLICABLE_ID = "applicable_id";
export const AUTO_ADJUST_SRP_EXCLUSION = "auto_adjust_srp_exclusion";
export const CAGE = "cage";
export const CATALOG = "catalog";
export const CATALOG_URL = "catalog_url";
export const CLASSIFIED_MEMO = "classified_memo";
export const COUNTRY_OF_MFG = "country_of_mfg";
export const DESCRIPTION = "description";
export const DOM = "dom";
export const DOM_LIFE_YEARS = "dom_life_years";
export const DOM_SENSITIVE = "dom_sensitive";
export const ESD = "esd";
export const EAR99 = "EAR99";
export const EXPENDABLE = "expendable";
export const SNCHK = "SNCHK";
export const EUROPEAN_COMMERCE_CONTROL_NUMBER =
  "european_commerce_control_number";
export const EXPORT_COMPLIANCE = "export_compliance";
export const HAZMAT = "hazmat";
export const BIO_HAZMAT = "bio_hazmat";
export const IMPORTANT_MEMO = "important_memo";
export const LLP = "llp";
export const MANUFACTURER = "manufacturer";
export const MASTER_PART_LOCK = "master_part_lock";
export const MILITARY = "military";
export const MLP = "manufacturer_list_price";
export const NSN = "national_stock_number";
export const PART = "part";
export const PART_NUMBER = "part_number";
export const PART_DESCRIPTION = "part_description";
export const PASS_FAIL = "pass_fail";
export const PERMANENT_EXTERNAL_NOTE_FOR_OQ = "outgoing_quote_external_note";
export const PURCHASED_AT = "purchased_at";
export const ROTABLE = "rotable";
export const SELLABLE_QUANTITIES = "sellable_quantities";
export const SHELF_LIFE = "shelf_life";
export const SPECIAL_CONTAINER_REQ = "special_container_req";
export const SPECIAL_CONTAINER_REQ_LABEL = "Special Container Required";
export const SPECIAL_CONTAINER_FEE = "special_container_fee";
export const TIER_TYPE = "tier_type";
export const TOOLING = "tooling";
export const TOOLING_PART_TYPE = "tooling_part_type";

export const TOOLING_PART_TYPES = [ROTABLE, EXPENDABLE, TOOLING];
export const TOTAL_CYCLES = "total_cycles";
export const TOTAL_HOURS = "total_hours";
export const UNITED_NATIONS_CODE = "united_nations_code";
export const UPDATED_AT = "updated_at";
export const WARRANTY_OVERRIDE = "warranty_override";

export const ATL = "ATL";
export const BTL = "BTL";
export const BBTL = "BBTL";
export const ZTL = "ZTL";
export const SATL = "SATL";
export const NON_QUALIFIER = "NON_QUALIFIER";

export const TIER_TYPES = [SATL, ATL, BTL, BBTL, ZTL, NON_QUALIFIER];

export const TIER_TO_STAR_MAP = {
  [SATL]: "5_star",
  [ATL]: "4_star",
  [BTL]: "3_star",
  [BBTL]: "2_star",
  [ZTL]: "1_star",
  [NON_QUALIFIER]: NON_QUALIFIER.toLowerCase()
};

export const APPLICATIONS = {
  [HIGHER_ASSEMBLY_APPLICATION]: {
    label: "Higher Assembly",
    applicationResourceName: "higher_assembly_applications",
    applicableResourceName: "parts",
    formResourceName: "higher_assembly_application",
    searchFilterParam: "part_number"
  },
  [LOWER_ASSEMBLY_APPLICATION]: {
    label: "Lower Assembly",
    applicationResourceName: "lower_assembly_applications",
    applicableResourceName: "parts",
    formResourceName: "lower_assembly_application",
    searchFilterParam: "part_number"
  },
  [ENGINE_APPLICATION]: {
    label: "Engine/APU",
    applicationResourceName: "engine_applications",
    applicableResourceName: "engines",
    formResourceName: "engine_application",
    searchFilterParam: "filter"
  },
  [AIRCRAFT_APPLICATION]: {
    label: "Aircraft",
    applicationResourceName: "aircraft_applications",
    applicableResourceName: "aircraft",
    formResourceName: "aircraft_application",
    searchFilterParam: "filter"
  }
};

export const EXACT = "exact";
export const FULLY_INTERCHANGEABLE = "fully_interchangeable";
export const REPLACES = "replaces";
export const REPLACED_BY = "replaced_by";
export const MODIFICATION = "modification";
export const MODEL_NUMBER = "model_number";
export const OEM = "oem";
export const PMA = "pma";
export const ANOMALY = "anomaly";
export const NATIONAL_STOCK_NUMBER = "national_stock_number";
export const UNKNOWN = "unknown";

export const ALTERNATE_TYPES = [
  EXACT,
  FULLY_INTERCHANGEABLE,
  OEM,
  REPLACES,
  REPLACED_BY,
  MODIFICATION,
  MODEL_NUMBER,
  PMA,
  ANOMALY,
  UNKNOWN
];

export const ALTERNATES = {
  [EXACT]: {
    label: "Exact"
  },
  [FULLY_INTERCHANGEABLE]: {
    label: "Fully Interchangeable"
  },
  [REPLACES]: {
    label: "Replaces"
  },
  [REPLACED_BY]: {
    label: "Replaced By"
  },
  [MODIFICATION]: {
    label: "Modification"
  },
  [MODEL_NUMBER]: {
    label: "Model No."
  },
  [OEM]: {
    label: "OEM"
  },
  [PMA]: {
    label: "PMA"
  },
  [ANOMALY]: {
    label: "Anomaly"
  },
  [NATIONAL_STOCK_NUMBER]: {
    label: "National Stock Number"
  },
  [UNKNOWN]: {
    label: "Unknown"
  }
};

export const ATTACHMENT_TYPES = {
  airline_requirements: {
    label: "Airline Requirements"
  },
  mod_sheets: {
    label: "Mod Sheets"
  },
  cmm_ipc: {
    label: "CMM / IPC"
  },
  ads_sbs: {
    label: "AD's / SB's"
  },
  interchangeability_ref: {
    label: "Interchangeability Ref."
  },
  msds: {
    label: "MSDS"
  },
  sales_brochure: {
    label: "Sales Literature / OEM Brochure"
  },
  stock_photo: {
    label: "Stock Photo (can be used for advertisements, etc.)"
  },
  external_link: {
    label: "External Link"
  }
};

export const TIER_TYPES_MAP = {
  [SATL]: "5-Star",
  [ATL]: "4-Star",
  [BTL]: "3-Star",
  [BBTL]: "2-Star",
  [ZTL]: "1-Star"
};

export const REPAIR_QUOTE_WARRANTY_PERIODS = {
  thirty_days: {
    label: "30 Days"
  },
  sixty_days: {
    label: "60 Days"
  },
  ninety_days: {
    label: "90 Days"
  },
  one_hundred_twenty_days: {
    label: "120 Days"
  },
  six_months: {
    label: "6 Months"
  },
  one_year: {
    label: "1 Year"
  },
  eighteen_months: {
    label: "18 Months"
  },
  twenty_four_months: {
    label: "24 Months"
  },
  thirty_six_months: {
    label: "36 Months"
  },
  no_warranty: {
    label: "No Warranty"
  }
};



// WEBPACK FOOTER //
// ./app/modules/parts/constants.js